module.exports = __webpack_public_path__ + "img/yellowabc.2ef1dfe1.png";